<template>
    <Content :class="[requireLocation && 'require-location']">
        <Modal
            :modal_id="modal_id"
            max_width_lg="500px"
            max_width_xl="500px"
            :has_header="!requireLocation"
        >
            <h2 class="text-center">
                Permitir que <strong>{{ url }}</strong> acesse sua localização?
            </h2>
            <div class="d-flex justify-content-center">
                <CancelButton
                    v-if="!company.require_location"
                    type="button"
                    class="mr-1"
                    @click="notAcceptLocation"
                >
                    Bloquear
                </CancelButton>
                <PrimaryButton type="button" @click="acceptLocation">
                    Permitir
                </PrimaryButton>
            </div>
        </Modal>
    </Content>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import { PrimaryButton, CancelButton } from "../Styles/Extends/styled";
import { Content } from "./style";
import Modal from "../Modal";
import { swall } from "../../services/sweetAlert";

export default {
    name: "ModalGeolocation",
    components: {
        Content,
        Modal,
        PrimaryButton,
        CancelButton
    },
    data() {
        return {
            modal_id: "modal_geolocation"
        };
    },
    mounted() {
        if (!this.use_location_popup) {
            return;
        }
        setTimeout(() => {
            if (this.company.use_location || this.company.require_location) {
                if (JSON.parse(sessionStorage.getItem("accepted"))) {
                    this.acceptLocation();
                } else if (
                    typeof JSON.parse(sessionStorage.getItem("accepted")) !=
                        "boolean" ||
                    this.requireLocation
                ) {
                    this.$root.showModalApp(this.modal_id);
                }
            }
        }, 2500);
    },
    methods: {
        ...mapActions("location", ["ActionGetLocation"]),
        acceptLocation() {
            this.ActionGetLocation();
            this.$root.closeModalApp(this.modal_id);
        },
        notAcceptLocation() {
            sessionStorage.setItem("accepted", false);
            this.$root.closeModalApp(this.modal_id);
        }
    },
    computed: {
        ...mapState("company", ["company"]),
        ...mapState("location", ["location"]),
        ...mapGetters("company", ["use_location_popup"]),
        url() {
            return window.location.hostname;
        },
        requireLocation() {
            return (
                !this.location &&
                !JSON.parse(sessionStorage.getItem("accepted")) &&
                this.company.require_location &&
                this.user_logged
            );
        },
        user_logged() {
            return this.$root.$children[0].$attrs.logged;
        }
    }
};
</script>
